import type { ComponentPublicInstance } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (
    error: unknown,
    context: ComponentPublicInstance | null,
  ) => {
    console.log(context, error)
  }
})
